/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminnav_Subscriptions1Inputs */

const zh_adminnav_subscriptions1 = /** @type {(inputs: Adminnav_Subscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅管理`)
};

const en_adminnav_subscriptions1 = /** @type {(inputs: Adminnav_Subscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription Management`)
};

const es_adminnav_subscriptions1 = /** @type {(inputs: Adminnav_Subscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión de suscripciones`)
};

/**
* | output |
* | --- |
* | "Subscription Management" |
*
* @param {Adminnav_Subscriptions1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminnav_subscriptions1 = /** @type {((inputs?: Adminnav_Subscriptions1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminnav_Subscriptions1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminnav_subscriptions1(inputs)
	if (locale === "en") return en_adminnav_subscriptions1(inputs)
	return es_adminnav_subscriptions1(inputs)
});
export { adminnav_subscriptions1 as "adminNav_subscriptions" }